import { useState } from "react";

import { Button } from "../../components/Button";
import { Hairline } from "../../components/Hairline";
import { Input } from "../../components/Input";
import { Label } from "../../components/Label";
import { Select } from "../../components/Select";

import { Drawer } from "../../components/Drawer";
import { Icon } from "../../components/core/Icon";
import styles from "./CashbackOperator.module.scss";

const steps = {
  CREATE: 1,
  EXCLUDED: 2,
  REMOVE: 3,
};

export default function CashbackOperator({ visible, onClose }) {
  const [currentStep, setCurrentStep] = useState(steps.CREATE);
  const [operatorName, setOperatorName] = useState("");
  const [newOperators, setNewOperators] = useState([]);
  const [originalOperators, setOriginalOperators] = useState([]);
  const [excludedOperators, setExcludedOperators] = useState([]);
  const [operatorToRemove, setOperatorToRemove] = useState(null);
  const [selectedUnit, setSelectedUnit] = useState(null);
  const [saving, setSaving] = useState(false);

  const options = [
    {
      label: "Unidade 1",
      value: 1,
    },
    {
      label: "Unidade 2",
      value: 2,
    },
    {
      label: "Unidade 3",
      value: 3,
    },
  ];

  const getRandomId = () => {
    return Math.floor(Math.random() * (9 - 0 + 1)) + 0;
  };

  const generateUniqueId = () => {
    let str = "";

    for (let i = 0; i < 5; i++) str += getRandomId();

    return str;
  };

  const addOperator = () => {
    const idExists = (string, array) => {
      return array.includes(string);
    };

    let uniqueId;

    do {
      uniqueId = generateUniqueId();
    } while (
      idExists(
        uniqueId,
        newOperators.map((o) => o.id)
      )
    );

    setNewOperators([
      ...newOperators,
      {
        id: uniqueId,
        name: operatorName,
        unit: selectedUnit,
        created_at: new Date(),
      },
    ]);
    setOperatorName("");
  };

  const removeOperator = () => {
    setNewOperators(
      newOperators.filter(
        (currentOperators) => currentOperators.id !== operatorToRemove.id
      )
    );

    setExcludedOperators((currentOperators) => [
      ...currentOperators,
      operatorToRemove,
    ]);
    setCurrentStep(steps.CREATE);
  };

  const confirmRemove = (operator) => {
    setCurrentStep(steps.REMOVE);
    setOperatorToRemove(operator);
  };

  const save = () => {
    return;
  };

  const hasNewOperators =
    JSON.stringify(originalOperators) !== JSON.stringify(newOperators);

  const sortedNewOperators = newOperators.sort(
    (a, b) => new Date(b.created_at) - new Date(a.created_at)
  );

  return (
    <Drawer
      title="Operadores"
      subtitle={
        currentStep === steps.EXCLUDED
          ? "Excluídos"
          : currentStep === steps.REMOVE
          ? `Operador ${operatorToRemove.id}`
          : null
      }
      visible={visible}
      showBackButton={currentStep !== steps.CREATE}
      backButton={() => setCurrentStep(steps.CREATE)}
      onClose={() => {
        setCurrentStep(steps.CREATE);

        if (currentStep === steps.CREATE) onClose && onClose();
      }}
    >
      {currentStep === steps.CREATE && (
        <>
          <Select
            label="Defina a unidade"
            value={selectedUnit}
            onChange={(e) => setSelectedUnit(e.target.value)}
            options={options}
          />

          <Hairline solid className="mt-20 mb-30" />

          <Label>Insira um operador</Label>
          <Input
            value={operatorName}
            onChange={(e) => setOperatorName(e.target.value)}
          />
          <Button
            onClick={addOperator}
            className="mt-15"
            disabled={operatorName.length < 1 || !operatorName}
          >
            Adicionar
          </Button>

          <Hairline solid className="mt-30 mb-30" />
          <Label>Operadores ({sortedNewOperators.length})</Label>

          {sortedNewOperators.length > 0 ? (
            <div className={styles.operators}>
              {sortedNewOperators.map((operator) => (
                <div className={styles.operator} key={operator.id}>
                  <div className="d-flex align-center">
                    <span className={styles.id}>{operator.id}</span>
                    <p>{operator.name}</p>
                  </div>
                  <div
                    className={styles.remove}
                    onClick={() => confirmRemove(operator)}
                  >
                    <Icon name="times" />
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className={styles.empty}>
              <div className={styles.icon}>
                <Icon name="id-card-clip" />
              </div>

              <p>Não há operadores listados no momento</p>
              <span>
                Por meio desta ferramenta, será possível contemplar adicionar
                novos operadores.
              </span>
            </div>
          )}
        </>
      )}

      {currentStep === steps.REMOVE && (
        <>
          <Label>
            Você tem certeza que deseja excluir o operador "
            {operatorToRemove.id}"?
          </Label>

          <Button
            design="primary"
            className="mt-30 mb-15 w-100"
            onClick={removeOperator}
          >
            Excluir
          </Button>
          <Button
            className="w-100"
            onClick={() => {
              setOperatorToRemove(null);
              setCurrentStep(steps.CREATE);
            }}
          >
            Cancelar
          </Button>
        </>
      )}

      {currentStep === steps.EXCLUDED && (
        <>
          <Label>Operadores excluídos ({excludedOperators.length})</Label>

          {excludedOperators.length > 0 ? (
            <div className={styles.operators}>
              {excludedOperators.map((operator) => (
                <div className={styles.operator} key={operator.id}>
                  <div className="d-flex align-center">
                    <span className={styles.id}>{operator.id}</span>
                    <p>{operator.name}</p>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className={styles.empty}>
              <div className={styles.icon}>
                <Icon name="id-card-clip" />
              </div>

              <p>Não há operadores excluídos no momento</p>
              <span>
                Por meio desta ferramenta, será possível visualizar os
                operadores excluídos.
              </span>
            </div>
          )}
        </>
      )}

      <div className={styles.footer}>
        {currentStep === steps.CREATE && hasNewOperators && (
          <Button
            className="w-100"
            onClick={save}
            design="primary"
            disabled={saving}
            loading={saving}
          >
            Salvar
          </Button>
        )}

        {excludedOperators.length > 0 && currentStep === steps.CREATE && (
          <div className="d-flex flex-column align-center mt-20 mb-10">
            <Button
              onClick={() => setCurrentStep(steps.EXCLUDED)}
              design="underline"
              disabled={saving}
              loading={saving}
            >
              Ver operadores excluídos
            </Button>
          </div>
        )}
      </div>
    </Drawer>
  );
}
